<template>
  <div>
    <div class="equipment-request-header tw-px-3 tw-py-1">
      Optional Equipment Information
    </div>
    <div class="divide-y bg-light tw-px-3">
      <div v-if="lineItem.quantity > 1" class="tw-py-4">
        <Select
          v-model="unitNumber"
          :options="unitOptions"
          label="Select Line Item"
          :full-width="false"
          placeholder="Select Line Item"
        />
      </div>
      <div class="tw-py-4">
        <Select
          v-model="equipmentId"
          full-width
          label="Use Existing Equipment (Optional)"
          :options="equipmentOptions"
          :placeholder="
            equipmentOptions.length ? 'Select...' : 'No available equipment'
          "
        >
          <template #item-row="{ option }">
            <div class="option-row">
              <span :class="{ 'tw-line-through': option.archived }">{{
                option.label
              }}</span>
              <span v-if="option.archived" class="tw-italic tw-ml-1"
                >(Archived)</span
              >
            </div>
          </template>
        </Select>
      </div>
      <div class="tw-flex tw-items-center tw-justify-between tw-py-4">
        <b>Add new equipment?</b>
        <SeraButton text="Add/Replace" @click="$emit('add-replace-click')" />
      </div>
    </div>
  </div>
</template>

<script>
import SeraButton from "@/components/Button.vue";

export default {
  name: "AdditionalEquipmentRequestForm",
  components: {
    SeraButton
  },
  props: {
    equipment: {
      type: Array,
      default: () => []
    },
    lineItem: {
      type: Object,
      required: true
    },
    showArchivedEquipment: {
      type: Boolean,
      default: false
    }
  },
  emits: ["add-replace-click", "create-equipment-link"],
  data() {
    return {
      equipmentId: null,
      unitNumber: 1
    };
  },
  computed: {
    equipmentOptions() {
      const filteredEquipment = this.equipment.filter((equipment) => {
        if (!this.showArchivedEquipment) return !equipment.archived;
        return true;
      });
      return filteredEquipment.map((eq) => ({
        label: eq.name,
        value: eq.id,
        archived: eq.archived
      }));
    },
    selectedEquipment() {
      if (!this.equipmentId) return null;
      return this.equipment.find((eq) => eq.id === this.equipmentId);
    },
    unitOptions() {
      const options = [];
      for (let i = 1; i <= this.lineItem.quantity; i++) {
        options.push({
          label: `${this.lineItem.unit_name} - Qty #${i} of ${this.lineItem.quantity}`,
          value: i
        });
      }
      return options;
    }
  },
  watch: {
    selectedEquipment(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.$emit("create-equipment-link", {
          equipment_id: newValue.id,
          equipment_type_id: newValue.equipment_type_id,
          unit_number: this.unitNumber
        });
      }
    }
  },
  methods: {
    resetForm() {
      this.equipmentId = null;
      this.unitNumber = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.field-label) {
  font-weight: bold;
}
.equipment-request-header {
  background: var(--tertiary-color);
  color: #fff;
  border-radius: 4px 4px 0 0;
}
.form-cont {
  border-radius: 0 0 4px 4px;
}
</style>
